/**
 * Copyright (C) Siemens AG 1996-2024 ALL RIGHTS RESERVED.
 */

import {Component, OnDestroy, OnInit, inject} from '@angular/core';
import {UserService} from '../../../services/user.service';
import {Subscription} from 'rxjs';

@Component({
  selector: 'app-organizations-settings',
  templateUrl: './organizations-settings.component.html',
  styleUrl: './organizations-settings.component.scss',
  standalone: false,
})
export class OrganizationsSettingsComponent implements OnInit, OnDestroy {
  private readonly userService = inject(UserService);

  private userDataSubscription?: Subscription;

  loading = true;
  orgName? = '';

  async ngOnInit() {
    this.userDataSubscription = this.userService.userDataChange.subscribe(
      async (user) => {
        if (user) {
          this.orgName = user?.organization.name;
          this.loading = false;
        }
      },
    );
  }

  ngOnDestroy() {
    this.userDataSubscription?.unsubscribe();
  }
}
